module.exports = __webpack_public_path__ + "img/bmw-ix-xdrive50.f55c96ef.jpg";